export enum AuthorityInsurer {
  REGISTER_INSURER_ACTIVE_DEACTIVE = '1.18.5',
  REGISTER_INSURER_EDIT = '1.18.4',
  REGISTER_INSURER_DELETE = '1.18.3',
  REGISTER_INSURER_ADD = '1.18.2',
  REGISTER_INSURER_VIEW = '1.18.1',
  REGISTER_INSURER_REGISTRATION = '1.18',
}
